import { useContext } from 'react';
import { Button, Table, Tag } from 'antd';
import { MessageOutlined, PlusOutlined } from '@ant-design/icons';

import useMessages from './useMessages';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function Messages() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        isGeneral,
        columns,
        tableData,
        totalItems,
        tableParams,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        handleClickCreateNewMessage,
        handleClickEditMessage,
    } = useMessages();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<MessageOutlined />}
                iconBg={
                    isGeneral
                        ? 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)'
                        : 'linear-gradient(135deg, #1677ff 0%, #0958d9 100%)'
                }
                title={isGeneral ? 'Mensagens Gerais' : 'Mensagens do Município'}
                tag={
                    <Tag color={isGeneral ? 'purple' : 'blue'}>
                        {poeValorComPontosEmMil(totalItems)} cadastrada{totalItems === 1 ? '' : 's'}
                    </Tag>
                }
                subtitle={
                    isGeneral
                        ? 'Gerencie comunicados e notificações gerais enviados para todos os cidadãos da plataforma.'
                        : 'Gerencie e envie comunicados e notificações para os cidadãos cadastrados no aplicativo do município.'
                }
                actions={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleClickCreateNewMessage}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Nova Mensagem
                    </Button>
                }
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha ou use o botão de ação para editar a mensagem." />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalItems}
                itemName="mensagens"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            handleClickEditMessage(record);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalItems}
                itemName="mensagens"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
